import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ContactLensesBundleBeneluxSolutionsContainer } from '../containers/ContactLensesBundleBeneluxSolutionsContainer.js';

const ContactLensesBundleBeneluxSolutions = (props)=>{
    return /*#__PURE__*/ React.createElement(ContactLensesBundleBeneluxSolutionsContainer, swcHelpers.extends({}, props));
};

export { ContactLensesBundleBeneluxSolutions };
//# sourceMappingURL=ContactLensesBundleBeneluxSolutions.js.map
